/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/coordinator/coordinator.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { CoordinatorRoutingModule } from "./coordinator-routing.module";
import * as i0 from "@angular/core";
export class CoordinatorModule {
}
CoordinatorModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CoordinatorRoutingModule,
                ],
            },] },
];
/** @nocollapse */ CoordinatorModule.ɵmod = i0.ɵɵdefineNgModule({ type: CoordinatorModule });
/** @nocollapse */ CoordinatorModule.ɵinj = i0.ɵɵdefineInjector({ factory: function CoordinatorModule_Factory(t) { return new (t || CoordinatorModule)(); }, imports: [[
            CoordinatorRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CoordinatorModule, { imports: [CoordinatorRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CoordinatorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CoordinatorRoutingModule,
                ],
            }]
    }], null, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29vcmRpbmF0b3IubW9kdWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vdmlzaW9uaWNzL25nL3NyYy9hcHAvY29vcmRpbmF0b3IvY29vcmRpbmF0b3IubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUV2QyxPQUFPLEVBQUMsd0JBQXdCLEVBQUMsTUFBTSw4QkFBOEIsQ0FBQzs7QUFPdEUsTUFBTSxPQUFPLGlCQUFpQjs7O1lBTDdCLFFBQVEsU0FBQztnQkFDUixPQUFPLEVBQUc7b0JBQ1Isd0JBQXdCO2lCQUN6QjthQUNGOztxREFDWSxpQkFBaUI7aUhBQWpCLGlCQUFpQixrQkFKbEI7WUFDUix3QkFBd0I7U0FDekI7d0ZBRVUsaUJBQWlCLGNBSDFCLHdCQUF3QjtrREFHZixpQkFBaUI7Y0FMN0IsUUFBUTtlQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUix3QkFBd0I7aUJBQ3pCO2FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge05nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuXG5pbXBvcnQge0Nvb3JkaW5hdG9yUm91dGluZ01vZHVsZX0gZnJvbSBcIi4vY29vcmRpbmF0b3Itcm91dGluZy5tb2R1bGVcIjtcblxuQE5nTW9kdWxlKHtcbiAgaW1wb3J0cyA6IFtcbiAgICBDb29yZGluYXRvclJvdXRpbmdNb2R1bGUsXG4gIF0sXG59KVxuZXhwb3J0IGNsYXNzIENvb3JkaW5hdG9yTW9kdWxlIHtcbn1cbiJdfQ==